// Configure Firebase.
export const firebaseConfig = {
  apiKey: "AIzaSyAB7ztPGfUrn3MruqZBJ_P82h1hrI0gX_k",
  authDomain: "always-be-accountable-to-me.firebaseapp.com",
  databaseURL: "https://always-be-accountable-to-me.firebaseio.com",
  projectId: "always-be-accountable-to-me",
  storageBucket: "always-be-accountable-to-me.appspot.com",
  messagingSenderId: "799684119178",
  appId: "1:799684119178:web:739de939fadc69e1"
};
